<template>
  <div class="d-flex order-first order-sm-last mb-2 mb-sm-0 align-self-end">
    <div ref="headlines" class="d-flex flex-column mr-4">
      <sf-text v-if="shippingCost.value > 0">{{ $t('order.shippingCostsGross') }}</sf-text>
      <sf-text v-if="quantitySurcharge && quantitySurcharge.value">{{
        $t('order.quantitySurcharge')
      }}</sf-text>
      <sf-text>{{ $t('order.totalCostsGross') }}</sf-text>
      <template v-for="(totalTax, index) in orderSumInformation.totalTaxes" :key="index">
        <sf-text ref="including-vat">
          {{ $t('includingVat', [getVatRateText(totalTax.vatPercent, portalSettings)]) }}
        </sf-text>
      </template>
      <sf-text>{{ $t('order.totalCostsNet') }}</sf-text>
    </div>
    <div class="d-flex flex-column align-end">
      <sf-text v-if="shippingCost.value > 0" ref="shipping-cost">
        {{ formatMoneyShowZeroPrice(shippingCost, false) }}
      </sf-text>
      <sf-text v-if="quantitySurcharge && quantitySurcharge.value" ref="quantity-surcharges">
        {{ formatMoneyShowZeroPrice(quantitySurcharge, false) }}
      </sf-text>
      <sf-text ref="gross-sum" class="font-weight-bold">
        {{ formatMoneyShowZeroPrice(orderSumInformation.grossSum, false) }}
      </sf-text>
      <template v-for="(totalTax, index) in orderSumInformation.totalTaxes" :key="index">
        <sf-text ref="tax-total">
          {{ formatMoneyShowZeroPrice(totalTax.vatSum, false) }}
        </sf-text>
      </template>
      <sf-text ref="net-sum">
        {{ formatMoneyShowZeroPrice(orderSumInformation.netSum, false) }}
      </sf-text>
    </div>
  </div>
</template>

<script setup lang="ts">
import SfText from '@/components/text/SfText.vue'
import { getVatRateText } from '@/modules/portalSettings/helpers'
import usePortalSettings from '@/modules/portalSettings/usePortalSettings'
import { formatMoneyShowZeroPrice } from '@/modules/product/helpers'
import { Money, OrderSumInformation } from '@/types/index'
import { storeToRefs } from 'pinia'
import { PropType } from 'vue'

defineProps({
  shippingCost: {
    type: Object as PropType<Money>,
    required: true
  },
  quantitySurcharge: {
    type: Object as PropType<Money>,
    default: undefined
  },
  orderSumInformation: {
    type: Object as PropType<OrderSumInformation>,
    required: true
  }
})

const { portalSettings } = storeToRefs(usePortalSettings())
</script>
